import { AxiosResponse } from "axios";
import { useQuery } from "react-query";
import { axiosAuthenticated } from "../../../service/http";
import { DashboardTotalsParameters } from "../models/DashboardTotalsParameters";
import { TotalsSuccessResponse } from "../models/TotalsSuccessResponse";

const cacheKeys = {
  dashboardTotals: "dashboard-totals",
};

// The "Today's performance" cards on the dashboard. The reports page that
// shared this endpoint moved to the new admin.
const getDashboardTotals = async (data: DashboardTotalsParameters) => {
  const { organizationKeyName, ...body } = data;
  const params = new URLSearchParams();
  Object.entries(body).forEach(([key, value]) => {
    if (value) {
      params.append(key, value);
    }
  });
  const url = `/organizations/${organizationKeyName}/reporting/totals-by-shop?${params.toString()}`;
  const response = await axiosAuthenticated.get<
    any,
    AxiosResponse<TotalsSuccessResponse>
  >(url);
  return response.data;
};

export const useGetDashboardTotals = (data: DashboardTotalsParameters) => {
  return useQuery<TotalsSuccessResponse, any>(
    [cacheKeys.dashboardTotals, data],
    () => getDashboardTotals(data),
    { refetchOnWindowFocus: false }
  );
};
